import * as Moment from 'moment';
import * as React from 'react';
import { WpdfText } from '../../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../../datenauswertung/pdf/WpdfView';

export interface LastgangJahreswerteProps {
    data: any;
    isPdf?: boolean;
}

export class LastgangJahreswerte extends React.Component<LastgangJahreswerteProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private avgLeistung: number = null;
    private dataMonate: any[] = [];
    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 1, useGrouping: true });
    private formatFloat1: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1, useGrouping: true });
    private formatFloat2: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
    private jahresauslastung: number = null;
    private maxLeistung: number = null;
    private minLeistung: number = null;
    private nutzungszeit: number = null;
    private unitLeistung: any = null;
    private unitVerbrauch: any = null;
    private verbrauch: number = null;

    componentDidMount(): void {
        this.init();
    }

    getKeyByUnit(name: string): string {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const powerUnits: any = data.powerUnits || {};
        const keys: string[] = [...Object.keys(energyUnits), ...Object.keys(powerUnits)];
        const units: any = data.units || {};
        let key: string = null;

        Object.keys(units).forEach((index: string) => {
            if (key === null && (units[index] || {}).key === name) {
                key = index;
            }
        });

        if (key === null && keys.indexOf(name) !== -1) {
            Object.keys(((data.data || {}).all || [])[0] || {}).forEach((key2: string) => {
                if (key === null && (key2 || '').toString().endsWith(`-${name}`)) {
                    key = key2;
                }
            });
        }

        return key;
    }

    getStyle(): any {
        const isPdf: boolean = this.props.isPdf || false;

        return ({
            tabelle: {
                fontSize: '9pt',
                maxWidth: 720,
                marginTop: 15,
                border: '1pt solid white',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                color: '#555',
                backgroundColor: '#ddd',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold',
                color: '#555'
                // backgroundColor: '#bccae3'
            },
            col_active: {
                color: 'white',
                backgroundColor: '#6692c3'
            },
            col1: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: '33.3%'
            },
            col1_2: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: '66.6%'
            },
            col1_3: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: '100%'
            },
            col1_header: {
            },
            col2: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: '33.3%'
            },
            col2_header: {
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                ...(!isPdf ? { alignItems: 'center' } : {}),
                boxSizing: 'border-box'
            },
            cell_header: {
                borderTop: 0,
                ...(!isPdf ? { alignItems: 'flex-start' } : {})
            },
            cell1: {
                borderLeft: 0
            },
            cell1_header: {
                textAlign: 'center',
                borderLeft: 0,
                justifyContent: 'center'
            },
            cell2: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell3: {
                textAlign: 'right',
                justifyContent: 'flex-end'
            },
            cell4: {
                borderLeftColor: '#ddd'
            },
            cell2_header: {
            },
            hinweis: {
                fontSize: '9pt',
                margin: '15px 20px 0 20px',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            bold: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold'
            },
            normal: {
                ...(isPdf ? { fontFamily: 'Helvetica' } : {}),
                fontWeight: 'normal'
            }
        });
    }

    init(): void {
        this.setUnits();
        const data: any = this.props.data || {};
        const dataJahr: any = ((data.data || {})['1#y'] || [])[0] || {};
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const keyVerbrauch: string = this.getKeyByUnit(this.unitVerbrauch) || null;
        const timestampFrom: number = data.timestampFrom || null;
        const timestampTo: number = data.timestampTo || null;
        const stunden: any[] = ((data.data || {}).all || [])
            .filter((item: any) => item.stamp >= timestampFrom && item.stamp <= timestampTo);
        const gesamtstunden: number = stunden.length
            ? Moment.duration((Moment.unix(stunden[stunden.length - 1].stamp / 1000)).diff(Moment.unix(stunden[0].stamp / 1000))).asHours()
            : 0;
        this.avgLeistung = dataJahr[keyLeistung] || null;
        this.dataMonate = [];
        this.maxLeistung = dataJahr[`${keyLeistung}-max`] || null;
        this.minLeistung = dataJahr[`${keyLeistung}-min`] || null;
        this.verbrauch = dataJahr[keyVerbrauch] || null;

        [...(data.data || {})['1#M'] || []].forEach((item: any) => {
            if (item.stamp >= timestampFrom && item.stamp <= timestampTo) {
                const leistung: number = +(item || {})[`${keyLeistung}-max`];
                const verbrauch: number = +(item || {})[keyVerbrauch];
                this.dataMonate.push({
                    leistung: !isNaN(leistung) ? this.formatFloat1.format(leistung) : null,
                    name: item.stamp > 0 ? Moment(item.datetime).format('MMM') : null,
                    nameFull: item.stamp > 0 ? Moment(item.datetime).format('MMMM') : null,
                    values: [verbrauch],
                    verbrauch: !isNaN(verbrauch) ? this.formatFloat1.format(verbrauch) : null
                });
            }
        });
        this.nutzungszeit = this.maxLeistung > 0 ? this.verbrauch / this.maxLeistung : null;
        this.jahresauslastung = this.nutzungszeit > 0 && gesamtstunden > 0
            ? (this.nutzungszeit / ((data.data || {})['1#h'] || []).length) * 100 : null
    }

    render(): JSX.Element[] {
        if (!this.props.data) {
            return null;
        }

        return [
            this.renderElektrischeArbeit(),
            this.renderElektrischeLeistung(),
            this.renderJahresuebersicht(),
            this.renderBenutzungsstunden(),
            this.renderJahresauslastung()
        ];
    }

    renderBenutzungsstunden(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView key='benutzungsstunden' style={{ ...styles.tabelle, marginTop: 15 }} pdf={isPdf}>
                <WpdfView style={styles.row} pdf={isPdf}>
                    <WpdfView style={styles.col1_2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, justifyContent: 'space-between' }} pdf={isPdf}>
                            <WpdfText style={styles.bold} pdf={isPdf}>Vollbenutzungsstunden</WpdfText>
                            <WpdfText pdf={isPdf}>{this.formatFloat2.format(this.nutzungszeit || 0)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={styles.col2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell4 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>h</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderElektrischeArbeit(): JSX.Element {
        const energyUnits: any = (this.props.data || {}).energyUnits || {};
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView key='elektrische-arbeit' style={styles.tabelle} pdf={isPdf}>
                <WpdfView style={styles.row} pdf={isPdf}>
                    <WpdfView style={styles.col1_2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, justifyContent: 'space-between' }} pdf={isPdf}>
                            <WpdfText style={styles.bold} pdf={isPdf}>Elektrische Arbeit</WpdfText>
                            <WpdfText pdf={isPdf}>{this.formatFloat.format(this.verbrauch || 0)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={styles.col2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell4 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>{energyUnits[this.unitVerbrauch] || ''}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderElektrischeLeistung(): JSX.Element {
        const powerUnits: any = (this.props.data || {}).powerUnits || {};
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView key='elektrische-leistung' style={{ ...styles.tabelle, marginTop: 15 }} pdf={isPdf}>
                <WpdfView style={styles.row} pdf={isPdf}>
                    <WpdfView style={styles.col1_3} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, justifyContent: 'space-between' }} pdf={isPdf}>
                            <WpdfText style={styles.bold} pdf={isPdf}>Elektrische Leistung</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {['Maximum', 'Minimum', 'Durchschnitt'].map((key: string, index: number) => {
                    const leistung: number = index === 0
                        ? this.formatFloat1.format(this.maxLeistung || 0)
                        : (index === 1
                            ? this.formatFloat1.format(this.minLeistung || 0)
                            : (index === 2 ? this.formatFloat1.format(this.avgLeistung || 0) : null)
                        );
                    return (
                        <WpdfView key={`leistung-${index}`} style={styles.row} pdf={isPdf}>
                            <WpdfView style={styles.col1} pdf={isPdf}>
                                <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{key}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView style={styles.col2} pdf={isPdf}>
                                <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{leistung}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView style={styles.col2} pdf={isPdf}>
                                <WpdfView style={styles.cell} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{powerUnits[this.unitLeistung] || null}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                    );
                })}
            </WpdfView>
        );
    }

    renderJahresauslastung(): JSX.Element {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return (
            <WpdfView key='jahresauslastung' style={{ ...styles.tabelle, marginTop: 15 }} pdf={isPdf}>
                <WpdfView style={styles.row} pdf={isPdf}>
                    <WpdfView style={styles.col1_2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1, justifyContent: 'space-between' }} pdf={isPdf}>
                            <WpdfText style={styles.bold} pdf={isPdf}>Jahresauslastung</WpdfText>
                            <WpdfText pdf={isPdf}>{this.formatFloat.format(this.jahresauslastung || 0)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={styles.col2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell4 }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>%</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderJahresuebersicht(): JSX.Element {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const isPdf: boolean = this.props.isPdf || false;
        const powerUnits: any = data.powerUnits || {};
        const styles: any = this.getStyle();

        return (
            <WpdfView key='jahresuebersicht' style={{ ...styles.tabelle, marginTop: 15 }} pdf={isPdf}>
                <WpdfView style={{ ...styles.row, ...styles.row_header }} pdf={isPdf}>
                    <WpdfView style={{ ...styles.col1, ...styles.col1_header, textAlign: 'center', justifyContent: 'center' }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1, ...styles.cell1_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>Monat</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.col2, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2, ...styles.cell2_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>
                                Verbrauch [{energyUnits[this.unitVerbrauch] || ''}]
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={{ ...styles.col2, ...styles.col2_header }} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2, ...styles.cell2_header }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>
                                Leistung [{powerUnits[this.unitLeistung] || ''}]
                            </WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
                {this.renderMonate()}
                <WpdfView style={styles.row} pdf={isPdf}>
                    <WpdfView style={styles.col1} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                            <WpdfText style={styles.bold} pdf={isPdf}>Summe</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={styles.col2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                            <WpdfText style={styles.bold} pdf={isPdf}>{this.formatFloat1.format(this.verbrauch || 0)}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    <WpdfView style={styles.col2} pdf={isPdf}>
                        <WpdfView style={{ ...styles.cell, ...styles.cell2, backgroundColor: 'white' }} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>&nbsp;</WpdfText>
                        </WpdfView>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderMonate(): JSX.Element[] {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return this.dataMonate.map((monat: any, index: number) =>
            <WpdfView key={`monat-${index}`} style={styles.row} pdf={isPdf}>
                <WpdfView style={styles.col1} pdf={isPdf}>
                    <WpdfView style={{ ...styles.cell, ...styles.cell1 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{monat.nameFull}</WpdfText>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={styles.col2} pdf={isPdf}>
                    <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{monat.verbrauch}</WpdfText>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={styles.col2} pdf={isPdf}>
                    <WpdfView style={{ ...styles.cell, ...styles.cell3 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{monat.leistung}</WpdfText>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    setUnits(): void {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const energyKeys: string[] = Object.keys(energyUnits);
        const powerUnits: any = data.powerUnits || {};
        const powerKeys: string[] = Object.keys(powerUnits);
        const units: any = data.units || {};

        Object.keys(units).forEach((index: string) => {
            if (this.unitLeistung === null && powerKeys.indexOf((units[index] || {}).key) !== -1) {
                this.unitLeistung = units[index].key;
                this.unitVerbrauch = energyUnits[`${this.unitLeistung}h`] ? `${this.unitLeistung}h` : null;
            }

            if (this.unitVerbrauch === null && energyKeys.indexOf((units[index] || {}).key) !== -1) {
                this.unitVerbrauch = units[index].key;
                const keyEnergy: string = this.unitVerbrauch.substr(0, this.unitVerbrauch.length - 1);
                this.unitLeistung = powerUnits[keyEnergy] ? keyEnergy : null;
            }
        });
    }
}
